module.exports = __webpack_public_path__ + "img/checkinapp-background.68e8efee.svg";